// AppGate — thin wrapper that renders the correct screen based on lock state.
// Do NOT put lock gating inside the main App component (gotcha #2: hooks must
// be called unconditionally). AppGate only calls useAppLock, then decides.
import React from 'react';
import { useAppLock } from './components/AppLock';
import { WelcomeScreen, SetupScreen, LockScreen } from './components/AppLock';
import { App } from './components/App'; // gotcha #3 — do NOT forget this import

export function AppGate(): React.ReactElement | null {
  const {
    isUnlocked,
    isConfigured,
    lock,
    isEnabled,
    decision,
    skipEncryption,
    enableEncryption,
  } = useAppLock();

  if (decision === 'pending') {
    return <WelcomeScreen onEnable={enableEncryption} onSkip={skipEncryption} />;
  }

  if (isEnabled && !isConfigured) {
    return (
      <SetupScreen
        onSubmit={async (password) => {
          if (!lock) return;
          await lock.setup(password);
        }}
        onSkip={skipEncryption}
      />
    );
  }

  if (isEnabled && isConfigured && !isUnlocked) {
    return (
      <LockScreen
        onUnlock={async (password) => {
          if (!lock) return false;
          return lock.unlock(password);
        }}
      />
    );
  }

  if (!isUnlocked) {
    return null;
  }

  return <App />;
}
